import { render } from "./RecieversGroupEditComponent.vue?vue&type=template&id=4fd00c6a&scoped=true"
import script from "./RecieversGroupEditComponent.vue?vue&type=script&lang=js"
export * from "./RecieversGroupEditComponent.vue?vue&type=script&lang=js"

import "./RecieversGroupEditComponent.vue?vue&type=style&index=0&id=4fd00c6a&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd00c6a"]])

export default __exports__